import React, { useState, useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    FormControl,
    FormLabel,
} from '@chakra-ui/react';

const RenameModal = ({ isOpen, onClose, onRename, currentName }) => {
    const [newName, setNewName] = useState(currentName || '');

    useEffect(() => {
        if (isOpen) {
            setNewName(currentName || '');
        }
    }, [isOpen, currentName]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (newName.trim()) {
            onRename(newName.trim());
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <form onSubmit={handleSubmit}>
                    <ModalHeader fontFamily="Inter" fontWeight="600">
                        Rename Conversation
                    </ModalHeader>
                    <ModalBody>
                        <FormControl>
                            <FormLabel fontFamily="Inter" fontSize="sm">
                                Conversation Name
                            </FormLabel>
                            <Input
                                value={newName}
                                onChange={(e) => setNewName(e.target.value)}
                                placeholder="Enter new name"
                                autoFocus
                                fontFamily="Inter"
                            />
                        </FormControl>
                    </ModalBody>
                    <ModalFooter>
                        <Button variant="ghost" mr={3} onClick={onClose} fontFamily="Inter">
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            colorScheme="brand"
                            isDisabled={!newName.trim()}
                            fontFamily="Inter"
                        >
                            Rename
                        </Button>
                    </ModalFooter>
                </form>
            </ModalContent>
        </Modal>
    );
};

export default RenameModal;